import { Button, FocusManager, NavigationManager, Row } from "@lightningjs/ui-components"
import { channel } from "diagnostics_channel"
import { REQUEST_STATUS } from "../../../enum"
import EpgChannel from "../epg-channel"
import EPGConfig from "../epg-config"
import EPGUtility from "../epg-utility"
import EpgProgram from "../epg-program"


export default class EPGRowUI extends FocusManager<FocusManager.TemplateSpec> implements FocusManager<FocusManager.TemplateSpec> {
    [x: string]: EpgChannel

    isLoaded = false
    static override _template() {
        return {
            // Channel: {
            //     x: -1*EPGConfig.ChannelWidth,
            //     w: EPGConfig.ChannelWidth,
            //     h: EPGConfig.ChannelRowHeight,
            //     rect: true,
            //     color: 0xff222222,
            //     type: Button,
            //     fixed: true,
            //     title: this.bindProp('title'),
            //     zIndex: 10
            // },
            ...super._template()
        }
    }

    static get __componentName(): string {
        return 'EPGRowUI'
    }

    static get tags() {
        return [...super.tags, ...['Channel']]
    }

    static get properties() {
        return [...super.properties, ...['title', 'fixed', 'channelIndex', 'epg', 'channel', 'timerange','focusTime']]
    }

    override _construct() {
        this.autoResizeHeight = false;
        super._construct();
    }

    override _init() {
        super._init()
    }

    _update() {
        super._update()
        this._updateChannel()
    }

    _updateChannel() {
        if(this.isLoaded) {
            this.selectedIndex = this._getProgramUIIndex()
        } else if (this._channel && !this.isLoaded) {
            const channel = this._channel as EpgChannel
            channel.fetchPromise.promise.then(() => {
                this.items = channel.createPrograms(this._timerange, this._channelIndex)
                this.selectedIndex = this._getProgramUIIndex()
                this.isLoaded = true
            })
        }
    }

    override onRight() {
        if(this.selected.et < this._getFocusTimelineRange().et) {
            this.selectNext()
        } else {
            this.fireAncestors('$onRight')
            return true
        }
    }

    override onLeft() {
        if(this.selected.st > this._getFocusTimelineRange().st) {
            this.selectPrevious()
        } else {
            this.fireAncestors('$onLeft')
            return true
        }
    }

    _getProgramUIIndex() {
        return this.items.findIndex(program => EPGUtility.isPlaying(program.st, program.et, this._focusTime))
    }

    _getFocusTimelineRange(): {st:Date,et:Date} {
        const st:Date = new Date(this._focusTime)
        const et:Date = new Date(this._focusTime)
        st.setMinutes(st.getMinutes()-15,0,0)
        et.setMinutes(et.getMinutes()+15,0,0)
        return {st,et}
    }
}
